import PermissionsSwitch from '../PermissionsSwitch/PermissionsSwitch';

type DownloadsEnabledForViewOnlySwitchProps = {
	enabled: boolean;
	onChange: ( enabled: boolean ) => void;
};

const DownloadsEnabledForViewOnlySwitch = ( { enabled, onChange }: DownloadsEnabledForViewOnlySwitchProps ) => (
	<PermissionsSwitch
		label="Download Files"
		description="Includes folders and previous rounds"
		checked={enabled}
		onChange={() => onChange( !enabled )}
		styles={{ root: { borderBottom: 'none' } }}
	/>
);

export default DownloadsEnabledForViewOnlySwitch;
